export default __webpack_public_path__ + "static/media/z1.619247c0.jpg";